import MockAdapter from 'axios-mock-adapter';

export function paymentMocks(mock: MockAdapter): void {
  mock
    .onGet(
      /\/api\/organizations\/[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}\/paymentAccounts/,
    )
    .reply(() => {
      const result = {
        paymentAccounts: [{ id: 1, type: 'stripe', creationDate: 1629400352253, name: 'SK_234-501239412341-22341' }],
      };
      return [200, result];
    });
}
